module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.wrap ? 'WrapperInput' : 'SingleInput', {
    tag: "component",
    attrs: {
      "value": _vm.date,
      "placeholder": _vm.placeholder,
      "inputClass": _vm.inputClass,
      "alignment": _vm.alignment
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c0dbac92"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-bulma-datepicker/src/index.vue
// module id = 235
// module chunks = 1